import React from 'react';

import HeroSection from '../sections/HeroSection/HeroSection';
import BasicSection from '../sections/BasicSection/BasicSection';
import AdvencedSection from '../sections/AdvencedSection/AdvencedSection';
import DescriptionSection from '../sections/DescriptionSection/DescriptionSection';
import ContactForm from '../sections/ContactForm/ContactForm';
import Slider from '../sections/Slider/Slider';

const Home = () => (
    <React.Fragment>
        <HeroSection title="Cześć" image="./assets/primary_slider.jpg" />
        <BasicSection
            title="O nas"
            image="./assets/big_logo.png"
            theme="black"
            rightColumn={
                <p>
                 Printlabel, to grupa ludzi świetnie wyszkolonych i gotowych
                 do działania. Potrafimy przygotować i zrealizować każdy projekt,
                 wiemy jak dobrze dobrać i wykorzystać różnorakie narzędzia
                 marketingowe, drukujemy etykiety w ilościach dużych i małych,
                 przygotowujemy przeróżne materiały poligraficzne (również
                 opakowania fasonowe). Jesteśmy gotowi zmierzyć się z każdym
                 zadaniem.  Na swoim koncie mamy cały wszechświat realizacji.
                 Każdy projekt był dla nas ważny i nad każdym pracowaliśmy z
                 pełnym zaangażowaniem
                </p>
            }
        />
        <AdvencedSection
            title="w czym możemy pomóc"
            theme="blue"
            items={[
                {title: 'poligrafia', image: './assets/mozemy_pomoc-poligrafia.png', link: '/poligrafia#poligrafia'},
                {title: 'druk etykiet', image: './assets/mozemy_pomoc-druk_etykiet.png', link: '/poligrafia#etykiety'},
                {title: 'projektowanie', image: './assets/mozemy_pomoc-projektowanie.png', link: '/studio'}
            ]}
        />
        <Slider
            items={[
                {
                  image: './assets/products/efiore/thumb.jpg',
                  link: '/realizacje/efiore'
                },
                {
                  image: './assets/products/glikol/thumb.jpg',
                  link: '/realizacje/glikol'
                },
                {
                  image: './assets/products/miodowy_ogrod/thumb.jpg',
                  link: '/realizacje/miodowy_ogrod'
                },
                {
                  image: './assets/products/bassau/thumb.jpg',
                  link: '/realizacje/bassau'
                },
                {
                  image: './assets/products/nails/thumb.jpg',
                  link: '/realizacje/nails'
                },
                {
                  image: './assets/products/nirobio/thumb.jpg',
                  link: '/realizacje/nirobio'
                },
              ]}
        />
        <DescriptionSection
            imageButton="./assets/faq-link.png"
            imageLink="/faq"
        >
            <React.Fragment>
                <h4>Masz jakieś pytania<br />
                    <b>- sprawdź FAQ.</b>
                </h4>
                <h4>
                    Jeśli nie znalazłeś odpowiedzi<br />
                    <b>- skontaktuj się z nami.</b>
                </h4>
            </React.Fragment>
        </DescriptionSection>
        <ContactForm />
        <DescriptionSection imageButton="./assets/allegro-link.png" externalLink="https://allegro.pl/uzytkownik/naturalnie_">
            <h4 className="text-start">
                <b>Print Label</b><br/>
                Przemysław Morel<br/>
                <b>tel.: 509 631 155</b><br/>
                44-100 Gliwice<br/>
                ul. Karolinki 58/112
            </h4>
        </DescriptionSection>
        
    </React.Fragment>
);

export default Home;